import React from 'react';

import classNames from 'classnames';

interface Props {
  customClassName?: string;
}

const Divider: React.FC<Props> = (props) => {
  const { customClassName } = props;

  return (
    <hr
      className={classNames('divider', {
        [customClassName]: customClassName,
      })}
    />
  );
};

export default Divider;
